import { Pipe, PipeTransform } from '@angular/core';

import { UserInterface } from 'app/core/user/models';

@Pipe({
  name: 'userInitials',
})
export class UserInitialsPipe implements PipeTransform {

  public transform(user: UserInterface, args?: any): string {

    let firstInitial: string;
    let lastInitial: string;
    if (user.firstName || user.lastName) {
      firstInitial = user.firstName.slice(0, 1).toUpperCase();
      lastInitial = user.lastName ? user.lastName.slice(0, 1).toUpperCase() : '';
    } else {
      firstInitial = user.userName.slice(0, 1).toUpperCase();
      lastInitial = '';
    }

    return `${firstInitial}${lastInitial}`;
  }

}
